<template>
  <div>
    {{ orderId }}
    <TheToolTip label="Link Hubble">
      <v-icon small class="ml-2" @click="loadContent(orderId)">
        mdi-link
      </v-icon>
    </TheToolTip>

    <TheToolTip label="Link Vtex">
      <v-icon small class="ml-2" @click="loadVtex(orderId)">
        mdi-shield-link-variant-outline
      </v-icon>
    </TheToolTip>
  </div>
</template>

<script>
import TheToolTip from '@/components/TheToolTip'

export default {
  components: {
    TheToolTip,
  },
  props: {
    orderId: String,
  },
  methods: {
    loadContent(order) {
      let route = this.$router.resolve({
        name: 'Order',
        params: { id: order },
      })
      window.open(route.href, '_blank')
    },
    loadVtex(order) {
      window.open(`https://lojawap.myvtex.com/admin/checkout/#/orders/${order}`, '_blank')
    },
  },
}
</script>

<style></style>
